import React, { useCallback } from "react";
import { connect } from "react-redux";

import MapTool from "@mapmycustomers/shared/enum/map/MapTool";

import useMapView from "@app/component/view/utils/useMapView";
import LassoToolPanel from "@app/scene/map/components/tools/LassoToolPanel";
import PinDropToolPanel from "@app/scene/map/components/tools/PinDropToolPanel";
import PinLocationToolPanel from "@app/scene/map/components/tools/PinLocationToolPanel";
import { selectMapTool } from "@app/scene/map/store/actions";

interface Props {
  selectMapTool: typeof selectMapTool;
  showLasso?: boolean;
}

const MapToolInformationPanel: React.FC<Props> = ({ selectMapTool, showLasso = true }) => {
  const { viewState } = useMapView();

  const handleExitInstrument = useCallback(() => selectMapTool(undefined), [selectMapTool]);

  switch (viewState.tool) {
    case MapTool.LASSO:
      return showLasso ? <LassoToolPanel onExit={handleExitInstrument} /> : null;
    case MapTool.PIN_LOCATION:
      return <PinLocationToolPanel />;
    case MapTool.DROP_PIN:
      return <PinDropToolPanel onExit={handleExitInstrument} />;
    default:
      return null;
  }
};

const mapDispatchToProps = {
  selectMapTool,
};

export default connect(null, mapDispatchToProps)(MapToolInformationPanel);
